import { Fare, FlightCard, FlightSegment, JsonsData, Sectors, SRPMiniRuleRequest } from '@/src/types/flight'
import { getFormattedDate } from '../../date'

export const getSRPMiniRuleRequest = (
    card: FlightCard,
    isMulticity: boolean,
    urlQueryObj: any,
    sectors: Sectors,
    formatDate: any,
    sid: string | null,
    jsons: JsonsData,
    solutionId?: string,
    sFare?: Fare
): SRPMiniRuleRequest => {
    // const card = cards[0]
    if (!card) {
        throw new Error('Invalid flight card data')
    }

    const [onwardKey, returnKey] = card.sectorKeys
    const onwardSector = sectors[onwardKey]
    const returnSector = card.sectorKeys.length === 2 ? sectors[returnKey] : null

    const onwardSegments = onwardSector.flights.segments
    const fares = sFare || card.priceBreakup.fare

    const from = onwardSegments[0].departure.airportCode
    const to = onwardSegments[onwardSegments.length - 1].arrival.airportCode
    const bc = fares.bc?.split(',')
    const fb = fares.fb
    let os: any[] = []
    if (isMulticity) {
        // Send one entry per sector (leg), not per segment. When a leg has layover
        // segments, collapse them: dep of the first segment, arr of the last segment,
        // and all other data taken from the first segment.
        os = card.sectorKeys.map((sectorKey: string) => {
            const segments = sectors[sectorKey].flights.segments
            const firstSegment = segments[0]
            const lastSegment = segments[segments.length - 1]
            const [airLineCode, flightNum] = firstSegment.flightNumber.split('-')
            return {
                bc: bc?.at(0) || '',
                fb: fb,
                al: airLineCode,
                dd: getFormattedDate(firstSegment.departure.date, 'DD-MM-YYYY'),
                sup: firstSegment.fk.split(`_${firstSegment.flightNumber}`)[0],
                arr: lastSegment.arrival.airportCode,
                dep: firstSegment.departure.airportCode,
                fn: flightNum,
                fareKey: fares.fk,
                solutionId
            }
        })
    } else {
        os = onwardSegments.map((segment: FlightSegment, index: number) => {
            const [airLineCode, flightNum] = segment.flightNumber.split('-')
            return {
                bc: bc?.[index] || bc?.at(0) || '',
                fb: fb,
                al: airLineCode,
                dd: getFormattedDate(segment.departure.date, 'DD-MM-YYYY'),
                sup: segment.fk.split(`_${segment.flightNumber}`)[0],
                arr: segment.arrival.airportCode,
                dep: segment.departure.airportCode,
                fn: flightNum,
                fareKey: fares.fk,
                solutionId
            }
        })
    }
    let rs: typeof os = []
    if (returnSector && !isMulticity) {
        const returnSegments = returnSector.flights.segments
        rs = returnSegments.map((segment: FlightSegment, index: number) => {
            const [airLineCode, flightNum] = segment.flightNumber.split('-')
            return {
                bc: bc?.[index] || bc?.at(0) || '',
                fb: fb,
                al: airLineCode,
                dd: getFormattedDate(segment.departure.date, 'DD-MM-YYYY'),
                sup: segment.fk.split(`_${segment.flightNumber}`)[0],
                arr: segment.arrival.airportCode,
                dep: segment.departure.airportCode,
                fn: flightNum,
                fareKey: fares.fk,
                solutionId
            }
        })
    }

    return {
        ADT: Number(urlQueryObj.adults),
        CHD: Number(urlQueryObj.childs),
        INF: Number(urlQueryObj.infants),
        intl: jsons.searchType?.isIntl ? 'Y' : 'N',
        scr: jsons.searchType?.sellCurr,
        sct: jsons.searchType?.sellingCountry,
        auid: jsons.userInfo?.auid || '',
        from,
        to,
        tt: isMulticity ? 'MULTI_CITY' : '',
        roundtrip: returnSector ? 'Y' : 'N',
        sid: sid || '',
        bp: fares.bp,
        oa: card.airlineCodes[0],
        routed: fares.fk && fares.fk.indexOf('route_id') > -1 ? 'Y' : 'N',
        os,
        rs
    }
}
